import axios from "axios";
import { useAuthStore } from "@/stores/auth";

// Opening the app from a "login as" link. Handled before the router's first
// navigation (router/index.ts awaits sessionReady()).
//
//   ?login_code=...   one-time code from "login as staff" (client/LoginAsStaff).
//                     Exchanged for a token via POST; the token never appears in a URL.
//   ?staff_token=...  token handed over by the admin app's "login as customer".
//
// Both parameters are removed from the address bar immediately.

let ready: Promise<void> = Promise.resolve();

function stripParams(params: URLSearchParams) {
  const search = params.toString();
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname + (search ? `?${search}` : "") + window.location.hash
  );
}

export function startSessionHandoff(): void {
  const params = new URLSearchParams(window.location.search);
  const loginCode = params.get("login_code");
  const staffToken = params.get("staff_token");
  if (!loginCode && !staffToken) return;

  params.delete("login_code");
  params.delete("staff_token");
  stripParams(params);

  const auth = useAuthStore();

  ready = (async () => {
    let token = staffToken;
    if (loginCode) {
      try {
        // plain axios: no stale Authorization header, no 401 redirect
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/api/auth/client/exchangeLoginCode`, {
          code: loginCode,
        });
        token = res.data?.access_token ?? null;
      } catch {
        token = null;
      }
    }
    if (!token) return;

    auth.clearAuth();
    auth.setToken(token);
    // Placeholder so fetchPermissions() proceeds; it is replaced by the real user.
    auth.setUser({});
    await auth.fetchPermissions();
  })();
}

export function sessionReady(): Promise<void> {
  return ready;
}
